function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "101.7%",
  height: "117.8%",
  x: "-.8%",
  y: "-8.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#5933B4",
  fillRule: "nonzero",
  stroke: "#5933B4",
  strokeWidth: 4.896,
  filter: "url(#a)",
  opacity: 0.07,
  transform: "translate(-898 -26)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M979.956 144.893c2.11 0 3.819-1.194 3.819-2.666 0-1.473-1.71-2.667-3.819-2.667h-34.821c-2.11 0-3.819 1.194-3.819 2.667 0 1.472 1.71 2.666 3.819 2.666h34.821zM953.636 31.333c-13.757 0-25.259 10.086-27.602 23.344C913.7 55.787 904 66.156 904 78.905c0 13.489 10.83 24.428 24.182 24.428H984v-4.408l-55.818-.735c-10.62 0-19.091-8.556-19.091-19.285 0-10.729 8.47-19.286 19.09-19.286a2.556 2.556 0 0 0 2.546-2.33c1.156-11.676 11.01-20.813 22.91-20.813 6.478 0 11.776 2.533 15.988 6.91a2.527 2.527 0 0 0 2.744.604c1.838-.705 4.457-1.085 6.722-1.085 9.144 0 16.75 6.828 17.818 15.71.11.973.758 1.799 1.67 2.129 7.274 2.697 12.33 9.767 12.33 18.16 0 10.73-8.47 19.286-19.09 19.286l-7.819.735v4.408h7.818c13.353 0 24.182-10.94 24.182-24.428 0-9.923-5.821-18.402-14.278-22.219-1.96-10.808-11.424-18.924-22.631-18.924-2.306 0-4.73.384-7 1.045-4.903-4.59-11.177-7.474-18.455-7.474zM927.915 122.46c0 1.473 1.709 2.666 3.818 2.666h61.625c2.109 0 3.818-1.193 3.818-2.666 0-1.473-1.71-2.667-3.818-2.667h-61.625c-2.109 0-3.818 1.194-3.818 2.667z"
}));

const SvgIcBannerCvs = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBannerCvs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-banner-cvs.bd9d1628.svg";
export { ForwardRef as ReactComponent };